<!-- Divider -->
<div class="expepharma-horizontal-navigation-item-wrapper divider" [ngClass]="item.classes?.wrapper"></div>
